import React from "react";
import {
  makeStyles,
  Divider,
  Container,
  Box,
  Card,
  CardContent,
  CardHeader,
} from "@material-ui/core";

import MaterialTable from "material-table";
import Page from "src/components/Page";
import { httpClient } from "src/utils/HttpClient";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    "& .MuiFormControl-root": {
      margin: theme.spacing(2),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    minWidth: 500,
  },
}));

export default function OverPeriodApprover() {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Approval Period">
      <Container maxWidth="sm">
        <Card>
          <CardHeader subheader="" title="Approval Period" />
          <Divider />
          <CardContent>
            <Box display="flex" flexDirection="column">
              <Box flexGrow={1}>
                <MaterialTable
                  title
                  columns={[
                    {
                      title: "Approve Type",
                      field: "APPROVE_TYPE",
                      editable: "never",
                    },
                    {
                      title: "Period",
                      field: "PERIOD_DAY",
                      type: "numeric",
                      editable: "onUpdate",
                      validate: (rowData) => {
                        return isNaN(rowData.PERIOD_DAY)
                          ? "Period can not be blank"
                          : "";
                      },
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      let url = "/backoffice/approver-period?";

                      url += "per_page=" + query.pageSize;
                      url += "&page=" + (query.page + 1);

                      if (query.orderBy) {
                        url += `&orderby=${query.orderBy.field},${query.orderDirection}`;
                      }

                      httpClient.get(url).then(({ data }) => {
                        resolve({
                          data: data.values,
                          page: data.currentPage - 1,
                          totalCount: data.totalPages,
                        });
                      });
                    })
                  }
                  editable={{
                    onRowUpdate: (newData, oldData) =>
                      new Promise((resolve, reject) => {
                        setTimeout(() => {
                          httpClient
                            .put(
                              "/backoffice/save-approve-period/" +
                                newData.PERIODIDX,
                              newData
                            )
                            .then(() => {
                              resolve();
                            })
                            .catch(() => reject());
                        }, 1000);
                      }),
                  }}
                  options={{
                    showFirstLastPageButtons: false,
                    search: false,
                    paging: false,
                    showTitle: false,
                  }}
                  style={{
                    width: "100%",
                  }}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
